import * as moment from 'moment';
import { ClientServiceProvider } from '../../../clients/services/client-service/client-service';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { FormField } from '../../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { FormGroup } from '@angular/forms';
import { IClientModel } from '../../../clients/interfaces/i-client-model.interface';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';
import { ProductServiceProvider } from '../../services/product-service';
import { ProjectMarketsServiceProvider } from '../../services/project-markets.service';
import { ProjectService } from '../../services/project.service';
import { SellionsFormsRendererComponent } from '../../../../submodules/sellions_forms/projects/forms/src/public-api';
import { Subscription } from 'rxjs';
import { TextServiceProvider } from '../../../core/services/text-service/text-service';

@IonicPage()
@Component({
  selector: 'page-project-add',
  templateUrl: 'project-add.html',
})
export class ProjectAddPage implements OnDestroy {
  @ViewChild(SellionsFormsRendererComponent)
  formRenderer: SellionsFormsRendererComponent;

  public form: FormField[] = [];
  public value: FormGroup = new FormGroup({});
  public client: IClientModel;
  public marketIds: Array<string>;
  private clients: any[] = [];
  private clientsFiltersSubscription: Subscription;

  constructor(
    private clientService: ClientServiceProvider,
    private navParams: NavParams,
    private productService: ProductServiceProvider,
    private projectMarketsService: ProjectMarketsServiceProvider,
    private projectService: ProjectService,
    private viewCtrl: ViewController,
    public config: ConfigServiceProvider,
    public textService: TextServiceProvider,
  ) {}

  ionViewWillEnter() {
    this.client = this.navParams.get('client');
    this.projectService
      .getCreateFormDefinition()
      .then((form: FormField[]) => {
        if (this.client) {
          const clientsSubform = form.find((field) => field.id === 'clients');
          clientsSubform.predefinedValue = [{ client: this.client }];
        }
        this.form = form;
      })
      .catch((error) => console.error(error));
  }

  ngOnDestroy(): void {
    this.unsubscribeClientsFilters();
    this.productService.unsubscribe();
    this.projectMarketsService.unsubscribeProjectMarkets();
  }

  unsubscribeClientsFilters() {
    if (this.clientsFiltersSubscription) {
      this.clientsFiltersSubscription.unsubscribe();
    }
  }

  onReferencesChange($event) {
    this.clients = $event.client;
  }

  watchChanges() {
    this.productService.watchProduct(this.formRenderer.form.controls['product']);
    this.watchClients();
    this.watchStartDate();
    this.watchEndDate();
  }

  private watchStartDate() {
    if (!this.formRenderer.form || !this.formRenderer.form.controls['startDate']) return;

    this.formRenderer.form.controls['startDate'].valueChanges.subscribe((date) => {
      if (this.isEndDateBeforeStartDate()) {
        this.formRenderer.form.controls['endDate'].patchValue(date);
      }
    });
  }

  private watchEndDate() {
    if (!this.formRenderer.form || !this.formRenderer.form.controls['endDate']) return;

    this.formRenderer.form.controls['endDate'].valueChanges.subscribe((date) => {
      if (this.isEndDateBeforeStartDate()) {
        this.formRenderer.form.controls['startDate'].patchValue(date);
      }
    });
  }

  private isEndDateBeforeStartDate(): boolean {
    return moment(this.getEndDate()).isBefore(this.getStartDate());
  }

  private getEndDate(): string {
    return this.formRenderer.form && this.formRenderer.form.controls['endDate'] && this.formRenderer.form.controls['endDate'].value;
  }

  private getStartDate(): string {
    return this.formRenderer.form && this.formRenderer.form.controls['startDate'] && this.formRenderer.form.controls['startDate'].value;
  }

  private watchClients() {
    if (!this.formRenderer.form || !this.formRenderer.form.controls['clients']) return;
    if (!this.clientsFiltersSubscription) {
      this.clientsFiltersSubscription = this.formRenderer.form.controls['clients'].valueChanges.subscribe((clients) => {
        clients.forEach((client: { client: string }, i: string) => {
          if (typeof client.client === 'string') {
            this.filterClients(client.client ? client.client.trim() : '', 'client' + i);
          } else {
            this.filterClients('', 'client' + i);
          }
        });
      });
    }

    this.marketIds = this.projectMarketsService.watchMarkets(this.formRenderer.form.controls['clients'], this.marketIds);
  }

  private filterClients(searchQuery: string, id: string) {
    this.formRenderer.references[id] = this.clients.filter((client) => this.clientService.checkAgainstClient(client, searchQuery));
  }

  assignValue(value: FormGroup) {
    this.value = value;
  }

  save() {
    this.viewCtrl.dismiss(this.value.getRawValue()).catch((err) => console.error(err));
  }

  close() {
    this.viewCtrl.dismiss().catch((err) => console.error(err));
  }
}



// WEBPACK FOOTER //
// ./src/modules/projects/pages/project-add/project-add.ts